package com.rainbowclubs.rainbow.domain.use_cases.membership

import com.rainbowclubs.rainbow.data.models.Membership
import com.rainbowclubs.rainbow.domain.repositories.MembershipRepository

class GetMembershipByIdUseCase(
    private val membershipRepository: MembershipRepository,
) {
    suspend operator fun invoke(membershipId: String): Result<Membership> {
        return membershipRepository.getMembershipById(membershipId)
    }
}
